<app-navigation></app-navigation>
<main>
    <section>
        <div id="carouselHome"
             class="carousel slide">
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <div class="container">
                        <div class="row d-flex align-items-center">
                            <div class="col-lg-5">
                                <div class="spacing-32">
                                    <div class="spacing-24">
                                        <div class="spacing-16">
                                            <p class="text-lg-medium color-primary-900 animate fadeIn delay-2 animated" i18n>"Innovation meets
                                                sustainability."</p>
                                            <h1 class="display-xl-bold color-text-primary" i18n>Welcome to
                                                <span class="color-primary-900">Octoplus</span>
                                            </h1>
                                        </div>
                                        <div>
                                            <p class="text-lg-medium color-text-tertiary" i18n>Our mission is to assist
                                                companies, from mid-sized to multinational, in enhancing their
                                                performance by advancing team maturity in factual cost management and
                                                carbon footprint monitoring.</p>
                                            <p class="text-lg-medium color-text-tertiary" i18n>
                                                Discover how our team of experts can transform your operations for a
                                                sustainable future.</p>
                                        </div>
                                    </div>
                                    <p>
                                        <a href="/about-us"
                                           class="btn btn-primary btn-arrow-left" i18n>Learn more
                                        </a>
                                    </p>
                                </div>
                            </div>
                            <div class="offset-lg-1 col-lg-6 mt-lg-0 mt-3">
                                <img src="./assets/home-1.jpg"
                                     class="img-fluid"
                                     i18n-alt alt="Octoplus hero image">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--            <div class="carousel-indicators">-->
            <!--                <button type="button"-->
            <!--                        data-bs-target="#carouselHome"-->
            <!--                        data-bs-slide-to="0"-->
            <!--                        class="active"-->
            <!--                        aria-current="true"-->
            <!--                        aria-label="Slide 1"></button>-->
            <!--                <button type="button"-->
            <!--                        data-bs-target="#carouselHome"-->
            <!--                        data-bs-slide-to="1"-->
            <!--                        aria-label="Slide 2"></button>-->
            <!--                <button type="button"-->
            <!--                        data-bs-target="#carouselHome"-->
            <!--                        data-bs-slide-to="2"-->
            <!--                        aria-label="Slide 3"></button>-->
            <!--            </div>-->
        </div>
    </section>
    <section class="py-48-64">
        <div class="container">
            <div class="partners">
                <div class="text-center">
                    <p class="text-md-medium color-muted" i18n>More than 30 companies trust us</p>
                    <div class="partnersLists">
                        <ul id="partnersList1"
                            class="partnersList">
                            <li>
                                <img src="../assets/partners/home/somfy.png"
                                     class="img-fluid "
                                     i18n-alt alt="Somfy logo">
                            </li>
                            <li>
                                <img src="../assets/partners/home/forvia.png"
                                     class="img-fluid "
                                     i18n-alt alt="Forvia logo">
                            </li>
                            <li>
                                <img src="../assets/partners/home/yazaki.png"
                                     class="img-fluid "
                                     i18n-alt alt="Yazaki logo">
                            </li>
                            <li>
                                <img src="../assets/partners/home/pandrol.png"
                                     class="img-fluid "
                                     i18n-alt alt="Pandrol logo">
                            </li>
                            <li>
                                <img src="../assets/partners/home/delachaux.png"
                                     class="img-fluid "
                                     i18n-alt alt="Delachaux logo">
                            </li>
                        </ul>
                        <ul id="partnersList2"
                            class="partnersList">
                            <li>
                                <img src="../assets/partners/home/mann-hummel.png"
                                     class="img-fluid "
                                     i18n-alt alt="Mann-Hummel logo">
                            </li>
                            <li>
                                <img src="../assets/partners/home/punch-powertrain.png"
                                     class="img-fluid "
                                     i18n-alt alt="Punch Powertrain logo">
                            </li>
                            <li>
                                <img src="../assets/partners/home/tesca.png"
                                     class="img-fluid "
                                     i18n-alt alt="Tesca logo">
                            </li>
                            <li>
                                <img src="../assets/partners/home/poclain.png"
                                     class="img-fluid "
                                     i18n-alt alt="Poclain logo">
                            </li>
                            <li>
                                <img src="../assets/partners/home/air-liquide.png"
                                     class="img-fluid "
                                     i18n-alt alt="Air Liquide logo">
                            </li>
                        </ul>
                    </div>

                </div>
                <p>
                    <a href="home#ourClients"
                       class="link link-primary link-arrow-bottom" i18n>Learn more about our references
                    </a>
                </p>
            </div>
        </div>
    </section>
    <section class="bg-color-light-extra py-100">
        <div class="spacing-40 container">
            <div class="spacing-16 pb-80">
                <p>
                    <span class="tag" i18n>Our mission</span>
                </p>
                <h2 class="display-md-medium" i18n>
                    <span class="color-primary-900">Empowering</span>
                    your teams for a sustainable future
                </h2>
                <p class="text-lg-medium color-tertiary" i18n>We support our clients in improving their performance by
                    transferring our proven methodologies and innovative digital tools, aimed at increasing the maturity
                    of their teams in the factual management of costs and the monitoring of the carbon footprint of
                    operations.</p>
            </div>
            <div class="row gx-5 align-items-center">
                <div class="col-md-6">
                    <div class="spacing-40">
                        <p class="text-lg-medium color-tertiary" i18n>Our team of experts is involved from the development of
                            the strategy and its implementation throughout the entire chain of operations.</p>
                        <div class="fxc gap-24">
                            <div class="fxac gap-12">
                                <div class="ico ico-40 color-primary-900 bg-specific-primary">
                                    <fa-icon [icon]="['far', 'lightbulb']"></fa-icon>
                                </div>
                                <span class="display-xs-medium color-tertiary" i18n>Product Development & Innovation</span>
                            </div>
                            <div class="fxac gap-12">
                                <div class="ico ico-40 color-primary-900 bg-specific-primary">
                                    <fa-icon [icon]="['far', 'link-horizontal']"></fa-icon>
                                </div>
                                <span class="display-xs-medium color-tertiary" i18n>Purchasing & Supply Chain</span>
                            </div>
                            <div class="fxac gap-12">
                                <div class="ico ico-40 color-primary-900 bg-specific-primary">
                                    <fa-icon [icon]="['far', 'gears']"></fa-icon>
                                </div>
                                <span class="display-xs-medium color-tertiary" i18n>Production</span>
                            </div>
                            <div class="fxac gap-12">
                                <div class="ico ico-40 color-primary-900 bg-specific-primary">
                                    <fa-icon [icon]="['far', 'joystick']"></fa-icon>
                                </div>
                                <span class="display-xs-medium color-tertiary" i18n>Controlling</span>
                            </div>
                            <div class="fxac gap-12">
                                <div class="ico ico-40 color-primary-900 bg-specific-primary">
                                    <fa-icon [icon]="['far', 'tags']"></fa-icon>
                                </div>
                                <span class="display-xs-medium color-tertiary" i18n>Sales</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 text-right mt-3 mt-md-0">
                    <img src="./assets/notre-mission.png"
                         class="img-fluid rounded"
                         i18n-alt alt="Our mission illustration">
                </div>
            </div>
            <div class="row gx-5 align-items-center">
                <div class="col-md-6 order-1 order-md-0 mt-3 mt-md-0">
                    <img src="./assets/notre-mission-2.png"
                         class="img-fluid rounded"
                         i18n-alt alt="Our vision illustration">
                </div>
                <div class="col-md-6">
                    <div class="spacing-16">
                        <p>
                            <span class="tag" i18n>Our vision</span>
                        </p>
                        <h2 class="display-md-medium" i18n>
                            Reinventing the
                            <span class="color-primary-900">customer-supplier</span>
                            business partnership
                        </h2>
                        <div>
                            <p class="text-lg-medium color-tertiary" i18n>
                                At Octoplus, our vision is to revolutionize the dynamics between customers and
                                suppliers,
                                ensuring that operations are as economically efficient as they are environmentally
                                sustainable.</p>
                            <p class="text-lg-medium color-tertiary" i18n>
                                We aim to lead by example, transforming business practices to foster both profitability
                                and reduced environmental impact.</p>
                            <p class="text-lg-medium color-tertiary" i18n>
                                With Octoplus, embrace a future where your operations are streamlined for success and
                                sustainability.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="bg-color-white py-64">
        <div class="container">
            <div class="spacing-40">
                <div class="spacing-16 mb-50 text-center">
                    <p>
                        <span class="tag" i18n>Applications</span>
                    </p>
                    <h2 class="display-md-medium" i18n>Our
                        <span class="color-primary-900"> services</span>
                    </h2>
                    <p class="text-lg-medium color-muted" i18n>Practical solutions for Cost Management and Environmental
                        Sustainability</p>
                </div>
                <div class="row align-items-stretch">
                    <div class="col-lg-4 pt-2 pt-lg-3">
                        <div class="box bg-color-light my-3 h-100">
                            <div class="ico specific-rose bg-specific-rose">
                                <fa-icon [icon]="['far', 'magnifying-glass-chart']"></fa-icon>
                            </div>
                            <div class="spacing-12">
                                <h3 class="display-xs-medium" i18n>Analyze</h3>
                                <p class="text-md-medium color-muted" i18n>Data-driven insights to streamline your cost
                                    management and operational efficiency</p>
                            </div>

                            <a href="/cost-viewer"
                               class="link link-primary-500 link-arrow-left" i18n> Know more
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-4 pt-2 pt-lg-3">
                        <div class="box bg-color-light my-3 h-100">
                            <div class="ico specific-primary bg-specific-primary">
                                <fa-icon [icon]="['fas', 'chalkboard-user']"></fa-icon>
                            </div>
                            <div class="spacing-12">
                            <h3 class="display-xs-medium" i18n>Train</h3>
                            <p class="text-md-medium color-muted" i18n>Expert-led courses designed to enhance your team's
                                cost management skills</p>
                            </div>
                            <a href="/training"
                               class="link link-primary-500 link-arrow-left" i18n> Know more
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-4 pt-2 pt-lg-3">
                        <div class="box bg-color-light my-3 h-100">
                            <div class="ico specific-orange bg-specific-orange">
                                <fa-icon [icon]="['fas', 'handshake-angle']"></fa-icon>
                            </div>
                            <div class="spacing-12">
                            <h3 class="display-xs-medium" i18n>Support</h3>
                            <p class="text-md-medium color-muted" i18n>Hands-on guidance with workshops to ensure the
                                successful transfer of know-how and best practices</p>
                            </div>
                            <a href="/about-us"
                               class="link link-primary-500 link-arrow-left" i18n> Know more
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-4 pt-2 pt-lg-3">
                        <div class="box bg-color-light my-3 h-100">
                            <div class="ico specific-primary bg-specific-primary">
                                <fa-icon [icon]="['fas', 'chart-line-up']"></fa-icon>
                            </div>
                            <div class="spacing-12">
                            <h3 class="display-xs-medium" i18n>Perpetuate</h3>
                            <p class="text-md-medium color-muted" i18n>Continuous support to maintain and improve performance
                                over time</p>
                            </div>
                            <a href="/dashboard-serie"
                               class="link link-primary-500 link-arrow-left" i18n> Know more
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-4 pt-2 pt-lg-3">
                        <div class="box bg-color-light my-3 h-100">
                            <div class="ico specific-purple bg-specific-purple">
                                <fa-icon [icon]="['fas', 'laptop']"></fa-icon>
                            </div>
                            <div class="spacing-12">
                            <h3 class="display-xs-medium" i18n>Digitalize</h3>
                            <p class="text-md-medium color-muted" i18n>Advanced digital tools to optimize your strategies and
                                decision-making processes</p>
                            </div>
                            <a href="/solutions"
                               class="link link-primary-500 link-arrow-left" i18n> Know more
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>
    <section class="bg-middle-bottom-light-extra pt-40">
        <div>
            <div class="container">
                <div class="our-objective-banner">
                    <div class="row align-items-center">
                        <div class="col-lg-9">
                            <div class="spacing-16">
                                <p>
                                    <img src="./assets/logo-white.svg"
                                         class="img-fluid"
                                         style="width:24px"
                                         i18n-alt alt="Octoplus logo">
                                </p>
                                <h2 class="display-md-medium color-white" i18n>Our goal</h2>
                                <p class="text-xl-medium color-light" i18n>By transferring our proven methodologies and
                                    leveraging scalable digital tools, we aim to elevate your team's performance,
                                    driving towards a sustainable competitive advantage in both economic and
                                    environmental realms</p>
                            </div>
                        </div>
                        <div class="col-lg-3 mt-4 mt-lg-0 ">
                            <p class="text-lg-right">
                                <a href="/contact-us"
                                   class="btn btn-light btn-arrow-left-white" i18n>Contact us
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-color-light-extra py-50">
            <div class="container">
                <div id="bigNumbers"
                     class="big-number row">
                    <div class="item col-md-3">
                        <div class="number display-lg-medium color-primary-500">
                            <span #count1 id="count1"
                                  data-count="3.5"
                                  data-type="decimal" i18n>3.5 B€
                            </span>
                        </div>
                        <span class="libelle text-lg-medium" i18n>analysed</span>
                    </div>
                    <div class="item col-md-3">
                        <div class="number display-lg-medium color-primary-500">
                            +
                            <span #count2 id="count2"
                                  data-count="3000"
                                  data-type="integer">3000
                            </span>
                        </div>
                        <span class="libelle text-lg-medium" i18n>people trained to
                            the methodology
                        </span>
                    </div>
                    <div class="item col-md-3">
                        <div class="number display-lg-medium color-primary-500">
                            +
                            <span #count3 id="count3"
                                  data-count="1100"
                                  data-type="integer">1100
                            </span>
                        </div>
                        <span class="libelle text-lg-medium color-tertiary" i18n>workshops completed</span>
                    </div>
                    <div class="item col-md-3">
                        <div class="number display-lg-medium color-primary-500">
                            +
                            <span #count4 id="count4"
                                  data-count="30"
                                  data-type="integer">30
                            </span>
                        </div>
                        <span class="libelle text-lg-medium color-tertiary" i18n>countries where Octoplus
                            CostViewer is used
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section id="ourClients"
             class="py-100">
        <div class="container">
            <div class="spacing-16 text-center pb-50">
                <p>
                    <span class="tag" i18n>Our clients</span>
                </p>
                <h2 class="display-md-medium" i18n>Our
                    <span class="color-primary-900">references</span>
                </h2>
            </div>
            <ul id="tabsJobs"
                class="nav nav-pills"
                role="tablist">
                <li class="nav-item"
                    role="presentation">
                    <span class="nav-link active"
                          id="pills-1-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-1"
                          type="button"
                          role="tab"
                          aria-controls="pills-1"
                          aria-selected="true">
                        <div class="item-job">
                            <i>
                                <fa-icon [icon]="['far', 'car']"></fa-icon>
                            </i>
                            <div class="libelle" i18n>
                                Automotive
                            </div>
                        </div>
                    </span>
                </li>
                <li class="nav-item"
                    role="presentation">
                    <span class="nav-link"
                          id="pills-2-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-2"
                          type="button"
                          role="tab"
                          aria-controls="pills-2"
                          aria-selected="true">
                        <div class="item-job">
                            <i>
                                <fa-icon [icon]="['far', 'rocket-launch']"></fa-icon>
                            </i>
                            <div class="libelle" i18n>
                                Aerospace
                            </div>
                        </div>
                    </span>
                </li>
                <li class="nav-item"
                    role="presentation">
                    <span class="nav-link"
                          id="pills-3-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-3"
                          type="button"
                          role="tab"
                          aria-controls="pills-3"
                          aria-selected="true">
                        <div class="item-job">
                            <i>
                                <fa-icon [icon]="['far', 'shield-quartered']"></fa-icon>
                            </i>
                            <div class="libelle" i18n>
                                Defense
                            </div>
                        </div>
                    </span>
                </li>
                <li class="nav-item"
                    role="presentation">
                    <span class="nav-link"
                          id="pills-4-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-4"
                          type="button"
                          role="tab"
                          aria-controls="pills-4"
                          aria-selected="true">
                        <div class="item-job">
                            <i>
                                <fa-icon [icon]="['far', 'train']"></fa-icon>
                            </i>
                            <div class="libelle" i18n>
                                Railway
                            </div>
                        </div>
                    </span>
                </li>
                <li class="nav-item"
                    role="presentation">
                    <span class="nav-link"
                          id="pills-5-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-5"
                          type="button"
                          role="tab"
                          aria-controls="pills-5"
                          aria-selected="true">
                        <div class="item-job">
                            <i>
                                <fa-icon [icon]="['far', 'truck']"></fa-icon>
                            </i>
                            <div class="libelle" i18n>
                                Truck & Off-road vehicles
                            </div>
                        </div>
                    </span>
                </li>
                <li class="nav-item"
                    role="presentation">
                    <span class="nav-link"
                          id="pills-6-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-6"
                          type="button"
                          role="tab"
                          aria-controls="pills-6"
                          aria-selected="true">
                        <div class="item-job">
                            <i>
                                <fa-icon [icon]="['far', 'house-medical']"></fa-icon>
                            </i>
                            <div class="libelle" i18n>
                                Pharmaceutical industry
                            </div>
                        </div>
                    </span>
                </li>
                <li class="nav-item"
                    role="presentation">
                    <span class="nav-link"
                          id="pills-7-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-7"
                          type="button"
                          role="tab"
                          aria-controls="pills-7"
                          aria-selected="true">
                        <div class="item-job">
                            <i>
                                <fa-icon [icon]="['far', 'gears']"></fa-icon>
                            </i>
                            <div class="libelle" i18n>
                                Process Industry
                            </div>
                        </div>
                    </span>
                </li>
                <li class="nav-item"
                    role="presentation">
                    <span class="nav-link"
                          id="pills-8-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-8"
                          type="button"
                          role="tab"
                          aria-controls="pills-8"
                          aria-selected="true">
                        <div class="item-job">
                            <i>
                                <fa-icon [icon]="['far', 'certificate']"></fa-icon>
                            </i>
                            <div class="libelle" i18n>
                                Consumer Goods
                            </div>
                        </div>
                    </span>
                </li>
            </ul>
            <div class="tab-content"
                 id="tabsJobsContent">
                <div class="tab-pane fade show active"
                     id="pills-1"
                     role="tabpanel"
                     aria-labelledby="pills-1-tab">
                    <div class="partners">
                        <ul class="partners-list-grid">
                            <li>
                                <img src="../assets/partners/automotive/forvia.svg"
                                     class="img-fluid "
                                     i18n-alt alt="Forvia logo">
                            </li>
                            <li>
                                <img src="../assets/partners/automotive/yazaki.svg"
                                     class="img-fluid "
                                     i18n-alt alt="Yazaki logo">
                            </li>
                            <li>
                                <img src="../assets/partners/automotive/mann-hummel.svg"
                                     class="img-fluid "
                                     i18n-alt alt="Mann-Hummel logo">
                            </li>
                            <li>
                                <img src="../assets/partners/automotive/punch-powertrain.svg"
                                     class="img-fluid "
                                     i18n-alt alt="Punch Powertrain logo">
                            </li>
                            <li>
                                <img src="../assets/partners/automotive/tesca.svg"
                                     class="img-fluid "
                                     i18n-alt alt="Tesca logo">
                            </li>
                            <li>
                                <img src="../assets/partners/automotive/autoliv.svg"
                                     class="img-fluid "
                                     i18n-alt alt="Autoliv logo">
                            </li>
                            <li>
                                <img src="../assets/partners/automotive/hutchinson.svg"
                                     class="img-fluid "
                                     i18n-alt alt="Hutchinson logo">
                            </li>
                            <li>
                                <img src="../assets/partners/automotive/valeo.svg"
                                     class="img-fluid "
                                     i18n-alt alt="Valeo logo">
                            </li>
                            <li>
                                <img src="../assets/partners/automotive/gkn.svg"
                                     class="img-fluid "
                                     i18n-alt alt="GKN logo">
                            </li>
                            <li>
                                <img src="../assets/partners/automotive/sogefi.svg"
                                     class="img-fluid "
                                     i18n-alt alt="Sogefi logo">
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="tab-pane fade"
                     id="pills-2"
                     role="tabpanel"
                     aria-labelledby="pills-2-tab">
                    <ul class="partners-list-grid">
                        <li>
                            <img src="../assets/partners/aerospace/thales.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Thales logo">
                        </li>
                        <li>
                            <img src="../assets/partners/aerospace/daher.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Daher logo">
                        </li>
                        <li>
                            <img src="../assets/partners/aerospace/hutchinson.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Hutchinson logo">
                        </li>
                        <li>
                            <img src="../assets/partners/aerospace/gkn.svg"
                                 class="img-fluid "
                                 i18n-alt alt="GKN logo">
                        </li>
                        <li>
                            <img src="../assets/partners/aerospace/safran.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Safran logo">
                        </li>
                    </ul>
                </div>
                <div class="tab-pane fade"
                     id="pills-3"
                     role="tabpanel"
                     aria-labelledby="pills-3-tab">
                    <ul class="partners-list-grid">
                        <li>
                            <img src="../assets/partners/defense/thales.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Thales logo">
                        </li>
                        <li>
                            <img src="../assets/partners/defense/hutchinson.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Hutchinson logo">
                        </li>
                        <li>
                            <img src="../assets/partners/defense/safran.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Safran logo">
                        </li>
                        <li>
                            <img src="../assets/partners/defense/ministere-interieur.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Ministry of Interior logo">
                        </li>
                    </ul>
                </div>
                <div class="tab-pane fade"
                     id="pills-4"
                     role="tabpanel"
                     aria-labelledby="pills-4-tab">
                    <ul class="partners-list-grid">
                        <li>
                            <img src="../assets/partners/railway/delachaux.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Delachaux logo">
                        </li>
                        <li>
                            <img src="../assets/partners/railway/pandrol.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Pandrol logo">
                        </li>
                        <li>
                            <img src="../assets/partners/railway/alstom.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Alstom logo">
                        </li>
                        <li>
                            <img src="../assets/partners/railway/wabtec.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Wabtec logo">
                        </li>
                    </ul>
                </div>
                <div class="tab-pane fade"
                     id="pills-5"
                     role="tabpanel"
                     aria-labelledby="pills-5-tab">
                    <ul class="partners-list-grid">
                        <li>
                            <img src="../assets/partners/truck/punch-powertrain.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Punch Powertrain logo">
                        </li>
                        <li>
                            <img src="../assets/partners/truck/thales.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Thales logo">
                        </li>
                        <li>
                            <img src="../assets/partners/truck/zf-wabco.svg"
                                 class="img-fluid "
                                 i18n-alt alt="ZF Wabco logo">
                        </li>
                    </ul>
                </div>
                <div class="tab-pane fade"
                     id="pills-6"
                     role="tabpanel"
                     aria-labelledby="pills-6-tab">
                    <ul class="partners-list-grid">
                        <li>
                            <img src="../assets/partners/pharmaceutical/air-liquide.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Air Liquide logo">
                        </li>
                    </ul>
                </div>
                <div class="tab-pane fade"
                     id="pills-7"
                     role="tabpanel"
                     aria-labelledby="pills-7-tab">
                    <ul class="partners-list-grid">
                        <li>
                            <img src="../assets/partners/process/delachaux.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Delachaux logo">
                        </li>
                        <li>
                            <img src="../assets/partners/process/tesca.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Tesca logo">
                        </li>
                        <li>
                            <img src="../assets/partners/process/air-liquide.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Air Liquide logo">
                        </li>
                        <li>
                            <img src="../assets/partners/process/conductix-wampfler.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Conductix Wampfler logo">
                        </li>
                        <li>
                            <img src="../assets/partners/process/cnim.svg"
                                 class="img-fluid "
                                 i18n-alt alt="CNIM logo">
                        </li>
                        <li>
                            <img src="../assets/partners/process/vallourec.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Vallourec logo">
                        </li>
                        <li>
                            <img src="../assets/partners/process/poclain.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Poclain logo">
                        </li>
                    </ul>
                </div>
                <div class="tab-pane fade"
                     id="pills-8"
                     role="tabpanel"
                     aria-labelledby="pills-8-tab">
                    <ul class="partners-list-grid">
                        <li>
                            <img src="../assets/partners/consumer/somfy.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Somfy logo">
                        </li>
                        <li>
                            <img src="../assets/partners/consumer/atlantic.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Atlantic logo">
                        </li>
                        <li>
                            <img src="../assets/partners/consumer/brandt.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Brandt logo">
                        </li>
                        <li>
                            <img src="../assets/partners/consumer/decathlon.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Decathlon logo">
                        </li>
                        <li>
                            <img src="../assets/partners/consumer/electrolux.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Electrolux logo">
                        </li>
                        <li>
                            <img src="../assets/partners/consumer/hager.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Hager logo">
                        </li>
                        <li>
                            <img src="../assets/partners/consumer/fenwich.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Fenwick logo">
                        </li>
                        <li>
                            <img src="../assets/partners/consumer/manitou.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Manitou logo">
                        </li>
                        <li>
                            <img src="../assets/partners/consumer/schneider.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Schneider logo">
                        </li>
                        <li>
                            <img src="../assets/partners/consumer/saft.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Saft logo">
                        </li>
                        <li>
                            <img src="../assets/partners/consumer/wilo.svg"
                                 class="img-fluid "
                                 i18n-alt alt="Wilo logo">
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</main>
<app-footer></app-footer>
